import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangleDown",
  "use": "icon-triangleDown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangleDown\"><path d=\"M130.255 321.128L512 702.872l381.745-381.745h-763.49z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol